export type AppType = 'organization' | 'client'

export function getAppType(): AppType {
  const href = window.location.href
  const u = new URL(href)

  return u.origin == process.env.NEXT_PUBLIC_CLIENTS_APP_URL ? 'client' : 'organization'
}
